import { Button, Grid, Typography } from "@mui/material";
import React from "react";

import colors from "../../../../styles/colors/colors";
import fontWeight from "../../../../styles/mui/fontWeight";
import { errorFallBackStyle } from "../styles/styles";

type ErrorFallbackProps = {
  error: Error;
  resetErrorBoundary: () => void;
  componentName?: string;
};

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  componentName,
}) => {
  return (
    <Grid sx={errorFallBackStyle}>
      <Typography
        variant="subtitle1"
        color={colors.fonts[20]}
        fontWeight={fontWeight.Weight[5]}
      >
        Error Loading: {componentName}
      </Typography>
      <Button>Contact to IT administrator</Button>
    </Grid>
  );
};

export default ErrorFallback;
